export const getS3CompletePathFromPreSigned = (url: string) => {
    if (!url) return "";

    return url.split("?")[0];
};

// Same object, differing only by signature — a reload would orphan the decode pipeline
export const isSameMediaSource = (a?: string, b?: string) => {
    if (!a || !b) return false;
    if (a === b) return true;
    if (a.startsWith("blob:") || b.startsWith("blob:")) return false;

    return (
        getS3CompletePathFromPreSigned(a) === getS3CompletePathFromPreSigned(b)
    );
};
